import React, { useState, useEffect, useCallback } from 'react';
import cep from 'cep-promise';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

// Redux
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '~/store/modules/instituitions/actions';

import { Switch } from 'antd';

// Components
import Breadcumbs from '~/components/Breadcumbs';
import Input from '~/components/Input';
import SelectInput from '~/components/Select';
import ButtonBase from '~/components/Button';
import BoxUploadComponent from '~/components/BoxUpload';
import BackButton from '~/components/BackButton';
import ErrorField from '~/components/ErrorField';

import {
  PageTitle,
  BoxContent,
  Container,
  Content,
  TitlePerfil,
  FormContainer,
  Label,
  BoxForm,
  TitleSection,
  TitleSectionLogo,
  Row,
  Col,
  ButtonBox,
  SwitchButton,
} from './style';

import VALIDATIONS from '~/helpers/validations';
import { maskCnpj, numberCNPJ } from '~/helpers/validationsCnpj';
import {
  estadosBrasileiros,
  onlyNumbers,
  onlyUpperCase,
} from '~/helpers/generalFunctions';
import { cepMask, phoneMask, cellPhoneMask } from '~/helpers/masks';

import { modalInativar, alertSaveUpload } from './messages';

const CadastroInstituicao = ({ match }) => {
  const dispath = useDispatch();
  const { roles, institutionId } = useSelector(state => state.auth);
  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
  const ROLE_USER = roles.includes('ROLE_USER');
  const ROLE_MANAGER = roles.includes('ROLE_MANAGER');

  const {
    loading,
    categoriesInstituitions,
    instituitionData: data,
  } = useSelector(state => state.instituitions);

  const [isActive, setIsActive] = useState(true);
  const [isEdition, setIsEdition] = useState(false);
  const [lockFields, setLockFields] = useState(false);
  const [logotipo, setLogotipo] = useState();

  const [changeMark, setChangeMark] = useState(false);
  const [changeMark2, setChangeMark2] = useState(false);

  useEffect(() => {
    if (data) {
      setChangeMark(data?.telefone?.length >= 16 ? true : false);
      setChangeMark2(data?.telefone2?.length >= 16 ? true : false);
    }
  }, [data]);

  useEffect(() => {
    if (match.path === '/administrador/adicionar-instituicao') {
      dispath(
        actions.getInstitutionSuccess({
          instituitionData: null,
        })
      );
    }

    if (
      match.params.id ||
      match.path === '/administrador/informacoes-institucionais' ||
      ROLE_MANAGER
    ) {
      dispath(
        actions.getInstitutionRequest({
          id: match.params.id || institutionId,
        })
      );
      setIsEdition(true);
    }

    if (ROLE_USER) {
      setLockFields(true);
    }
  }, [match]);

  useEffect(() => {
    dispath(actions.listCategoriesRequest());
  }, []);

  const submitLogotipo = useCallback(() => {
    const logoFile = document.getElementById('perfilUpload').files[0];
    dispath(
      actions.uploadLogoRequest({
        image: logotipo || logoFile,
      })
    );
  }, [dispath]);

  const handleLogo = useCallback(
    e => {
      setLogotipo(e.target.files[0]);
    },
    [setLogotipo]
  );

  const formik = useFormik({
    initialValues: {
      cnes: data?.cnes || '',
      nomeFantasia: data?.nomeFantasia || '',
      razaoSocial: data?.razaoSocial || '',
      sigla: data?.sigla || '',
      categoria: data?.categoria?.codigo || '',
      cnpj: data?.cnpj || '',
      cep: data?.cep.replace(/^(\d{5})(\d{3}).*/, '$1-$2') || '',
      bairro: data?.bairro || '',
      numero: data?.numero || '',
      cidade: data?.cidade || '',
      telefone: data?.telefone || '',
      endereço: data?.endereco || '',
      complemento: data?.complemento || '',
      estado: data?.estado || '',
      phone2: data?.telefone2 || '',
      ativo: isEdition ? data?.ativo : true,
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      cnes: Yup.string()
        .required('Campo obrigatório')
        .length(7, 'Mínimo 7 dígitos')
        .matches(/^([0-9]+)$/, '* Somente números'),
      nomeFantasia: VALIDATIONS.requiredString,
      razaoSocial: VALIDATIONS.requiredString,
      sigla: VALIDATIONS.requiredString,
      categoria: VALIDATIONS.requiredString,
      cnpj: VALIDATIONS.cnpj,
      cep: VALIDATIONS.cep,
      numero: VALIDATIONS.numero,
      cidade: VALIDATIONS.requiredString,
      bairro: VALIDATIONS.requiredString,
      telefone: VALIDATIONS.requiredString,
      endereço: VALIDATIONS.requiredString,
      estado: VALIDATIONS.requiredString,
      ativo: Yup.bool().required('Campo obrigatório'),
    }),
    onSubmit: async (values, { setErrors }) => {
      
      const data = {
        ...values,
        cnpj: numberCNPJ(values.cnpj),
      };

      // if (ROLE_ADMIN)
      dispath(
        actions.newInstitutionRequest({
          data,
          image: logotipo ? logotipo : null,
          idEdition: isEdition ? match.params.id || institutionId : null,
        })
      );
    },
  });

  // Pesquisa CEP

  const getCep = useCallback(async value => {
    let response;
    try {
      response = await cep(`${value}`);

      if (response) {
        const { city, neighborhood, state, street } = response;

        formik.setFieldValue('cidade', city);
        formik.setFieldValue('estado', state);
        formik.setFieldValue('endereço', street || '');
        formik.setFieldValue('bairro', neighborhood || '');
      }
    } catch (error) {
      toast.warning('Cep não encontrado.');
    }
  }, []);

  const onChangeActive = useCallback(val => {
    if (!val) {
      Swal.fire(modalInativar).then(result => {
        if (result.value) {
          setIsActive(false);
          formik.setFieldValue('ativo', false);
          return;
        }
        setIsActive(true);
        formik.setFieldValue('ativo', true);
      });
    } else {
      setIsActive(true);
      formik.setFieldValue('ativo', true);
    }
  }, []);

  useEffect(() => {
    const countErrors = Object.keys(formik.errors).length;
    if (countErrors >= 1 && formik.isSubmitting) {
      toast.error('Preencha todos os campos obrigatórios.', {
        autoClose: 6000,
      });
    }
  }, [formik.errors]);

  const alertSaveChanges = useCallback(() => {
    Swal.fire(alertSaveUpload);
  }, []);

  return (
    <>
      <Breadcumbs
        path="adicionar-nova-instituicao"
        pathTitle="Adicionar nova instituição"
        routeId={match?.params?.id}
      />
      <PageTitle>
        <BackButton />
        <div>
          {!isEdition ? (
            <span>Adicionar nova instituição</span>
          ) : (
            <span>Dados Institucionais</span>
          )}
        </div>
      </PageTitle>
      <BoxContent>
        <Container>
          <Content>
            {isEdition && !ROLE_ADMIN && (
              <TitlePerfil>
                <span>
                  Para alterar dados cadastrais, contate a equipe administradora
                  do sistema.
                </span>
              </TitlePerfil>
            )}

            {!isEdition && (
              <h3>
                Preencha as informações abaixo para <br />
                cadastrar uma <span>nova instituição</span>:
              </h3>
            )}

            <FormContainer>
              <form onSubmit={formik.handleSubmit} method="post">
                <BoxForm>
                  <div className="left">
                    <TitleSection> Informações de cadastro</TitleSection>

                    <Row>
                      <Col>
                        <Input
                          disabled={!ROLE_ADMIN}
                          label="CNES: *"
                          name="cnes"
                          id="cnes"
                          value={formik.values.cnes}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'cnes',
                              onlyNumbers(target.value)
                            );
                          }}
                          maxLength="7"
                          hasError={
                            formik.errors.cnes && formik.touched.cnes
                              ? formik.errors.cnes
                              : ''
                          }
                        />

                        <p>Somente números, sem pontos</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={!ROLE_ADMIN}
                          label="Nome fantasia da Instituição: *"
                          name="nomeFantasia"
                          id="nomeFantasia"
                          value={formik.values.nomeFantasia}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'nomeFantasia',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.nomeFantasia &&
                            formik.touched.nomeFantasia
                              ? formik.errors.nomeFantasia
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={!ROLE_ADMIN}
                          label="Razão social da Instituição: * "
                          name="razaoSocial"
                          id="razaoSocial"
                          value={formik.values.razaoSocial}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'razaoSocial',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.razaoSocial &&
                            formik.touched.razaoSocial
                              ? formik.errors.razaoSocial
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={!ROLE_ADMIN}
                          label="SIGLA: *"
                          name="sigla"
                          id="sigla"
                          value={formik.values.sigla}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'sigla',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.sigla && formik.touched.sigla
                              ? formik.errors.sigla
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <SelectInput
                          disabled={!ROLE_ADMIN}
                          label="Categoria: *"
                          name="categoria"
                          id="categoria"
                          value={formik.values.categoria}
                          onChange={formik}
                          hasError={
                            formik.errors.categoria && formik.touched.categoria
                              ? formik.errors.categoria
                              : ''
                          }
                          selectData={categoriesInstituitions || {}}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={!ROLE_ADMIN}
                          label="CNPJ: *"
                          name="cnpj"
                          id="cnpj"
                          value={formik.values.cnpj}
                          maskRegex={maskCnpj}
                          onChange={formik.handleChange}
                          hasError={
                            formik.errors.cnpj && formik.touched.cnpj
                              ? formik.errors.cnpj
                              : ''
                          }
                        />
                        <p>Somente letras e números</p>
                      </Col>
                    </Row>
                  </div>
                  <div className="right">
                    <TitleSectionLogo>
                      <TitleSection> Logotipo da instituição: </TitleSection>
                      {ROLE_MANAGER && <span>Alterável</span>}
                    </TitleSectionLogo>

                    <p>
                      Use o botão abaixo para fazer upload do logotipo da
                      <br />
                      instituição:
                    </p>

                    <BoxUploadComponent
                      urlLogo={data?.urlLogo}
                      setLogo={handleLogo}
                    />

                    <p style={{ textAlign: 'center' }}>
                      Formatos de imagem aceitos: .jpg ou .png
                    </p>

                    {isEdition && ROLE_ADMIN && (
                      <Row>
                        <Col>
                          <SwitchButton>
                            <Label>Status de atividade</Label>
                            <Switch
                              defaultChecked
                              checked={formik.values.ativo}
                              onChange={onChangeActive}
                            />
                            {formik.values.ativo ? (
                              <span
                                style={{ marginLeft: 10, color: '#74a50a' }}
                              >
                                Instituição ativa
                              </span>
                            ) : (
                              <span
                                style={{ marginLeft: 10, color: '#6c6c6c' }}
                              >
                                Instituição inativa
                              </span>
                            )}
                            <br />
                            {formik.errors.ativo && formik.touched.ativo && (
                              <ErrorField message={formik.errors.ativo} />
                            )}
                          </SwitchButton>
                        </Col>
                      </Row>
                    )}
                  </div>
                </BoxForm>

                <hr />

                <BoxForm>
                  <div className="left">
                    <TitleSection> Informações de cadastro</TitleSection>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="CEP: *"
                          name="cep"
                          id="cep"
                          value={formik.values.cep}
                          maskRegex={cepMask}
                          onChange={formik.handleChange}
                          onBlur={e => getCep(e.target.value)}
                          hasError={
                            formik.errors.cep && formik.touched.cep
                              ? formik.errors.cep
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="Bairro: *"
                          name="bairro"
                          id="bairro"
                          value={formik.values.bairro}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'bairro',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.bairro && formik.touched.bairro
                              ? formik.errors.bairro
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="Número: * "
                          name="numero"
                          id="numero"
                          value={formik.values.numero}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'numero',
                              onlyNumbers(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.numero && formik.touched.numero
                              ? formik.errors.numero
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="Cidade: * "
                          name="cidade"
                          id="cidade"
                          value={formik.values.cidade}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'cidade',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.cidade && formik.touched.cidade
                              ? formik.errors.cidade
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="DDD + Telefone: * "
                          name="telefone"
                          id="telefone"
                          placeholder="(00) 0000-0000"
                          value={formik.values.telefone}
                          maskRegex={changeMark ? cellPhoneMask : phoneMask}
                          onChange={({ target }) => {
                            const splitValue = target?.value?.split('');
                            if (splitValue?.[5] === '9') {
                              setChangeMark(true);
                            } else {
                              setChangeMark(false);
                            }
                            formik.setFieldValue('telefone', target?.value);
                          }}
                          hasError={
                            formik.errors.telefone && formik.touched.telefone
                              ? formik.errors.telefone
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="right">
                    <TitleSection> </TitleSection>
                    <br />

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="Logradouro (Rua, Avenida…): *"
                          name="endereço"
                          id="endereço"
                          value={formik.values.endereço}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'endereço',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.endereço && formik.touched.endereço
                              ? formik.errors.endereço
                              : ''
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="Complemento:"
                          name="complemento"
                          id="complemento"
                          value={formik.values.complemento}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'complemento',
                              onlyUpperCase(target.value)
                            );
                          }}
                        />
                        {formik.errors.numero && formik.touched.numero && (
                          <span> &nbsp;</span>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <SelectInput
                          disabled={lockFields}
                          label="Estado (UF): *"
                          name="estado"
                          id="estado"
                          value={formik.values.estado}
                          onChange={formik}
                          hasError={
                            formik.errors.estado && formik.touched.estado
                              ? formik.errors.estado
                              : ''
                          }
                          selectData={estadosBrasileiros}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Input
                          disabled={lockFields}
                          label="DDD + Telefone (2):"
                          name="phone2"
                          id="phone2"
                          placeholder="(00) 0000-0000"
                          value={formik.values.phone2}
                          maskRegex={changeMark2 ? cellPhoneMask : phoneMask}
                          onChange={({ target }) => {
                            const splitValue = target?.value?.split('');
                            if (splitValue?.[5] === '9') {
                              setChangeMark2(true);
                            } else {
                              setChangeMark2(false);
                            }
                            formik.setFieldValue('phone2', target?.value);
                          }}
                          hasError={
                            formik.errors.phone2 && formik.touched.phone2
                              ? formik.errors.phone2
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </BoxForm>

                {!ROLE_USER && (
                  <ButtonBox>
                    <ButtonBase disabled={loading && true} type="submit">
                      {loading ? (
                        'Enviando dados...'
                      ) : (
                        <>
                          {isEdition
                            ? 'Salvar alterações'
                            : 'Próximo (Cadastrar Gestor)'}
                        </>
                      )}
                    </ButtonBase>
                  </ButtonBox>
                )}

                {!isEdition && (
                  <span className="alertGreen">*Preenchimento obrigatório</span>
                )}
              </form>
            </FormContainer>
          </Content>
        </Container>
      </BoxContent>
    </>
  );
};

export default CadastroInstituicao;
